const VIDEO_OVERLAY_IMAGE_SIZES = ["(min-width: 915px) 60vw", "99vw"];

// duplicates in
// app/components/CardCQW/components/CardThumbnail/utils.tsx
export const getVideoPlaceholderImageProps = (image) => {
    const imgProps = {
        src: "",
        srcSet: null,
        sizes: null,
    };

    if (image?.url) {
        const urlParts = image.url.split("?");
        urlParts[0] = encodeURI(urlParts[0]);
        const encodedThumbnail = urlParts.join("?");

        imgProps.src = encodedThumbnail;
        imgProps.srcSet = image.srcset || [];
        imgProps.sizes = image.srcset ? VIDEO_OVERLAY_IMAGE_SIZES : null;
    }

    return imgProps;
};

// duplicated in
// app/components/VideoLinkImageOverlay/constants.js
export const getVideoPlaceholderPlayBtn = () => (
    <svg
        className="videoItemPlayBtn"
        role="img"
        width="34px"
        height="34px"
        viewBox="0 0 34 34"
        aria-label="Play"
        data-testid="videoItemPlayBtn"
    >
        <circle fill="#FFFFFF" cx="16.5" cy="16.5" r="16.5"></circle>
        <path
            d="M12.0627845,9.87071431 L24.510661,16.6074648 C24.6396791,16.677289 24.6876652,16.8384825 24.617841,16.9675006 C24.5925502,17.0142319 24.553825,17.0523041 24.5066704,17.0767967 L12.0587939,23.5423393 C11.9286072,23.6099595 11.768253,23.5592393 11.7006328,23.4290526 C11.6809874,23.3912301 11.6707317,23.3492356 11.6707317,23.3066154 L11.6707317,10.1043222 C11.6707317,9.95762156 11.7896561,9.8386972 11.9363567,9.8386972 C11.9805052,9.8386972 12.0239575,9.84970124 12.0627845,9.87071431 Z"
            fill="#000000"
        ></path>
    </svg>
);
